module.exports = __webpack_public_path__ + "img/qrcode1.79f97350.png";